import {
  resolveBool,
  resolveColorName,
  resolveContentBlocks,
  resolveImageReference,
  resolveNumber,
  resolveSpacingSize,
  resolveString,
} from '@/utils/resolvers';
import React, { useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import ContentList from './ContentList';

const MappedContentList = ({
  content,
  presentation,
  containerTopBackgroundImage,
  contentButtons,
}: any) => {
  const { containerBackgroundColor } = presentation || {};
  return (
    <div
      data-datalayer-position="content_list"
      data-datalayer-variant={presentation?.datalayerVariant}
    >
      <ContentList
        content={content}
        presentation={{
          ...presentation,
          containerTopBackgroundImage,
          containerTopBackgroundColor: containerBackgroundColor,
          containerBottomBackgroundColor: containerBackgroundColor,
        }}
        contentButtons={contentButtons}
      />
    </div>
  );
};

const ContentListCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        listSuperheading: null,
        listTitle: null,
        contentList: [null, resolveContentBlocks],
      },
    ],
    imageDocument: ['containerTopBackgroundImage', resolveImageReference],
    componentParameterMap: [
      'presentation',
      {
        'content-list-template': ['template', resolveString],
        'card-color': ['cardColor', resolveColorName],
        'bottom-spacing': ['containerBottomSpacing', resolveSpacingSize],
        'top-spacing': ['containerTopSpacing', resolveSpacingSize],
        'container-background-color': ['containerBackgroundColor', resolveColorName],
        'Text Shadow': ['hasTextShadow', resolveBool],
        'background-overlay-opacity': ['backgroundOverlayOpacity', resolveNumber],
        'text-color': 'textColor',
        'variant-label': 'datalayerVariant',
        'column-number': ['columnNumber', resolveNumber],
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedContentList}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default ContentListCMSWrapper;
